import { useFetch } from '@/hooks/use-fetch';
import { useTypedSelector } from '@/hooks/use-typed-selector';
import { useQuery } from '@tanstack/react-query';
import { IUseAllActiveComapny } from './get-all-active-company.props';
import { ResponseModel } from '@/common/interfaces';

export const useAllActiveComapany = (companyIdProps?: string, enabled = true) => {
  const user = useTypedSelector(state => state.app.user);

  const companyId = companyIdProps || user.companyId;
  const QUERY_KEY = 'useAllActiveComapny';

  const { fetch } = useFetch<ResponseModel<IUseAllActiveComapny>>({
    loadingKey: QUERY_KEY,
    method: 'POST',
    url: 'Company/GetAllActiveCompany',
    data: { AccountId: companyId }
  });

  const { data, ...restQueryProps } = useQuery({
    queryKey: [QUERY_KEY, companyId],
    queryFn: () => fetch(),
    enabled: enabled && !!companyId
  });

  return { allActiveComapany: data?.data.data, ...restQueryProps };
};
